'use client';

import { useSyncExternalStore } from 'react';

const subscribeNoop = () => () => {};

/**
 * `false` during SSR + the first client render, `true` once mounted — with no
 * hydration mismatch (the server and first client render both read `false` via
 * `useSyncExternalStore`'s `getServerSnapshot`). Use to gate anything that must
 * run only after hydration (canvas/blurhash decode, `window`/`localStorage`
 * reads, etc.).
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribeNoop,
    () => true,
    () => false,
  );
}
